export default {
  name: 'TabToggle',
  props: {
    disabled: Boolean,
    size: { type: String, default: 'default', validator: value => ['default', 'small'].includes(value) },
    modelValue: {
      type: [String, Number, Boolean],
      default: null,
    },
    options: {
      type: Array,
      default: () => [],
    },
    ariaLabel: {
      type: String,
      default: null,
    },
  },
  emits: ['update:modelValue', 'change'],
  computed: {
    resolvedAriaLabel() {
      return this.ariaLabel || this.$t('common.tabToggle');
    },
  },
  methods: {
    getOptionValue(option) {
      return option?.value ?? option?.key;
    },

    isActive(option) {
      return this.modelValue === this.getOptionValue(option);
    },

    getOptionLabel(option) {
      return option?.labelKey ? this.$t(option.labelKey) : option?.label;
    },

    selectOption(option) {
      if (this.disabled || option.disabled) return;
      const value = this.getOptionValue(option);
      this.$emit('update:modelValue', value);
      this.$emit('change', value);
    },
  },
};
